"use client";

import { useI18n } from "@wojo/localization";
import { Button, ModalBody, ModalFooter, Text } from "@wojo/ui";
import Link from "next/link";

type CloseGateProps = {
    closeModal: () => void;
    redirectLink?: string;
    returnToTerms: () => void;
    titleId: string;
};

export const CloseGate: React.FC<CloseGateProps> = ({
    closeModal,
    redirectLink,
    returnToTerms,
    titleId,
}) => {
    const i18n = useI18n("account").account.termsAndConditionsModal.closeGate;

    return (
        <>
            <ModalBody
                style={{
                    textAlign: "center",
                }}
            >
                <Text.Heading
                    id={titleId}
                    order="3"
                    tag="h1"
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {i18n.title.l()}
                </Text.Heading>
                <Text.Body>{i18n.description.l()}</Text.Body>
            </ModalBody>
            <ModalFooter
                style={{
                    textAlign: "center",
                }}
            >
                <div style={{ marginBottom: "var(--g-spacing-md)" }}>
                    <Button
                        variant="primary"
                        type="button"
                        onClick={() => returnToTerms()}
                    >
                        {i18n.returnToTermsButton.l()}
                    </Button>
                </div>
                {redirectLink ? (
                    <Button variant="quiet" href={redirectLink} tag={Link}>
                        {i18n.closeButton.l()}
                    </Button>
                ) : (
                    <Button
                        variant="quiet"
                        onClick={closeModal}
                        tag="button"
                        type="submit"
                    >
                        {i18n.closeButton.l()}
                    </Button>
                )}
            </ModalFooter>
        </>
    );
};
